import graphql__506b9d9925381afb905e from "./__generated__/EventDetails_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import isSameDay from "date-fns/isSameDay";

import EventCalendarDropdownButton from "./EventCalendarDropdownButton";
import PageSections from "../PageSection/PageSections";
import EventMap from "./EventMap";
import Icon from "../Utils/Icon";
import { Mobile } from "../Utils/ResponsiveQueries";
import parseDate from "../Utils/parseDate";
import { useFormatTime, useFormatDate, useFormatMessage } from "../Intl/Context";
import { isAuthorized, isUnauthorized } from "../Utils/authorizations";

const EventDetails = props => {
  const participativeModule = useFragment(
    EventDetails_participativeModule,
    props.participativeModule
  );
  const { visualization: event } = participativeModule;
  const { maximumSeats, remainingSeats, alreadySubmitted } = event;
  const { contributionsSubmissionAuthorized } = participativeModule.authorizations;
  const { displayMaximumSeats, displayRemainingSeats } = event.authorizations;

  const formatTime = useFormatTime();
  const formatDate = useFormatDate();

  const startsAtTime = event.startsAt && parseDate(event.startsAt);
  const startTime = startsAtTime && formatTime(startsAtTime);
  const startDate = startsAtTime && formatDate(startsAtTime);

  const endsAtTime = event.endsAt && parseDate(event.endsAt);
  const endTime = endsAtTime && formatTime(endsAtTime);

  const startsAtDate = event.startsAt && parseDate(event.startsAt);
  const endsAtDate = event.endsAt && parseDate(event.endsAt);

  const t = useFormatMessage();
  const labels = {
    mapTitle: t(intlMessages.mapTitle),
    alreadySubscribed: t(intlMessages.alreadySubscribed, {
      b: message => `<b>${message}</b>`
    }),
    noSeatsRemaining: t(intlMessages.noSeatsRemaining),
    exceededMaximumSubscriptions: t(intlMessages.exceededMaximumSubscriptions),
    startEndTimeSpan: t(intlMessages.startEndTimeSpan, {
      startTime,
      endTime
    }),
    maximumSeats:
      isAuthorized(displayMaximumSeats) &&
      t(intlMessages.maximumSeats, {
        count: maximumSeats
      }),
    remainingSeats:
      isAuthorized(displayRemainingSeats) &&
      t(intlMessages.remainingSeats, {
        count: remainingSeats,
        total: maximumSeats
      })
  };

  const times =
    endsAtDate && isSameDay(startsAtDate, endsAtDate)
      ? labels.startEndTimeSpan
      : startTime;

  const isSubscriptionAuthorized = !isUnauthorized(contributionsSubmissionAuthorized);

  const noSeatsRemaining = remainingSeats === 0;
  const seatsLabelName = isAuthorized(displayRemainingSeats)
    ? "remainingSeats"
    : "maximumSeats";

  const cannotSubscribeMessage =
    !isSubscriptionAuthorized &&
    ((alreadySubmitted && labels.exceededMaximumSubscriptions) ||
      (noSeatsRemaining && labels.noSeatsRemaining));

  return (
    <>
      <div className="box margin-bottom-xs padding-md clearfix">
        <div className="with-icon-lg float-md-left text-metric-md">
          <Icon className="icon-calendar text-primary" />

          <span className="with-icon-text text-capitalize">{startDate}</span>
        </div>

        <Mobile>
          <hr />
        </Mobile>

        <div className="with-icon-lg float-md-right text-metric-md">
          <Icon className="icon-time text-primary" />

          <span className="with-icon-text">{times}</span>
        </div>

        <div className="clearfix" aria-hidden="true" />

        {isAuthorized(displayMaximumSeats) && (
          <p className="float-right text-right text-muted margin-top-sm margin-bottom-none">
            {labels[seatsLabelName]}
          </p>
        )}

        <EventCalendarDropdownButton participativeModule={participativeModule} />
      </div>

      {cannotSubscribeMessage && (
        <div className="box padding-md margin-bottom-xs d-flex align-items-center">
          <Icon className="icon-infos text-lg text-primary text-greater margin-right-xs" />
          <div dangerouslySetInnerHTML={{ __html: cannotSubscribeMessage }} />
        </div>
      )}

      <PageSections
        page={participativeModule}
        className="sections-list-modal margin-bottom-xs"
      />

      <EventMap event={event} />
    </>
  );
};

const EventDetails_participativeModule = graphql__506b9d9925381afb905e;

export default EventDetails;

export const intlMessages = defineMessages({
  mapTitle: {
    id: "event.show.mapTitle",
    defaultMessage: "Lieu de l'évènement"
  },
  alreadySubscribed: {
    id: "event.show.alreadySubscribed",
    defaultMessage: "<b>Attention</b> : Vous êtes déjà inscrit(e) à cet évènement."
  },
  exceededMaximumSubscriptions: {
    id: "event.show.exceededMaximumSubscriptions",
    defaultMessage: "Vous vous êtes déjà inscrit(e) à cet évènement."
  },
  noSeatsRemaining: {
    id: "event.show.noSeatsRemaining",
    defaultMessage: "Il n'y a plus de places disponibles pour cet évènement."
  },
  maximumSeats: {
    id: "event.show.maximumSeats",
    defaultMessage: "Nombre de places totales : {count}"
  },
  remainingSeats: {
    id: "event.show.remainingSeats",
    defaultMessage: "Nombre de places restantes : {count} / {total}"
  },
  startEndTimeSpan: {
    id: "event.show.startEndTimeSpan",
    defaultMessage: "De {startTime} à {endTime}"
  }
});
